import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

interface Post {
  id: number;
  category: string;
  title: string;
  content: string;
  author: string;
  avatar: string;
  date: string;
  views: number;
  likes: number;
  comments: number;
  isHot?: boolean;
  image?: string;
}

export default function Community() {
  const [isNavFixed, setIsNavFixed] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('전체');
  const navigate = useNavigate();

  const categories = [
    { name: '전체', icon: 'ri-apps-line' },
    { name: '네일아트', icon: 'ri-hand-heart-line' },
    { name: '속눈썹', icon: 'ri-eye-line' },
    { name: '왁싱', icon: 'ri-heart-pulse-line' },
    { name: '피부관리', icon: 'ri-heart-3-line' },
    { name: '헤어', icon: 'ri-scissors-line' },
    { name: '메이크업', icon: 'ri-palette-line' },
    { name: '고민상담', icon: 'ri-chat-heart-line' },
    { name: '뷰티팁', icon: 'ri-lightbulb-line' },
    { name: '제품추천', icon: 'ri-shopping-bag-line' },
    { name: '샵후기', icon: 'ri-star-line' },
  ];

  const hotPosts: Post[] = [
    {
      id: 1,
      category: '네일아트',
      title: '여름 네일 디자인 추천해주세요! 🌊',
      content: '다음주에 제주도 여행 가는데 어울릴만한 네일 디자인 찾고 있어요. 바다 느낌 나는 청량한 디자인 추천 부탁드려요!',
      author: '민지',
      avatar: 'https://public.readdy.ai/ai/img_res/031e11cad2a5b5fdcf202ea985b4be9a.jpg',
      date: '2시간 전',
      views: 1247,
      likes: 89,
      comments: 34,
      isHot: true,
      image: 'https://readdy.ai/api/search-image?query=beautiful-summer-ocean-inspired-nail-art-design-with-blue-gradient-seashells-pearls-glitter-elegant-feminine-manicure-on-natural-nails-soft-pastel-colors-professional-beauty-photography-clean-white-background&width=800&height=500&seq=comm002&orientation=landscape'
    },
    {
      id: 2,
      category: '고민상담',
      title: '속눈썹 연장 처음인데 자연스러운 게 좋을까요?',
      content: '다음주에 첫 속눈썹 연장 예약했는데 너무 티나는 건 부담스러워서요. 자연스러운 스타일 추천해주세요!',
      author: '수현',
      avatar: 'https://readdy.ai/api/search-image?query=elegant-korean-woman-in-her-twenties-with-shoulder-length-brown-hair-wearing-beige-sweater-gentle-smile-natural-beauty-soft-lighting-clean-background-professional-portrait&width=200&height=200&seq=comm003&orientation=squarish',
      date: '5시간 전',
      views: 892,
      likes: 67,
      comments: 28,
      isHot: true
    },
    {
      id: 3,
      category: '뷰티팁',
      title: '네일 오래 유지하는 꿀팁 공유합니다 💅',
      content: '젤네일 한 지 3주 됐는데도 멀쩡해요! 제가 관리하는 방법 공유할게요. 첫째, 손 씻을 때 네일 부분은...',
      author: '지은',
      avatar: 'https://readdy.ai/api/search-image?query=pretty-korean-woman-with-wavy-long-hair-wearing-pink-blouse-bright-smile-fresh-makeup-natural-daylight-clean-white-background-professional-beauty-portrait&width=200&height=200&seq=comm004&orientation=squarish',
      date: '1일 전',
      views: 2341,
      likes: 156,
      comments: 42,
      isHot: true
    }
  ];

  const recentPosts: Post[] = [
    {
      id: 4,
      category: '샵후기',
      title: '강남 다움네일살롱 다녀왔어요!',
      content: '프렌치 네일 받았는데 너무 예쁘게 해주셨어요. 디자이너분도 친절하시고 샵 분위기도 좋았습니다.',
      author: '예린',
      avatar: 'https://readdy.ai/api/search-image?query=young-korean-woman-with-short-bob-haircut-wearing-white-shirt-natural-smile-minimal-makeup-soft-studio-lighting-clean-background-professional-portrait&width=200&height=200&seq=comm005&orientation=squarish',
      date: '30분 전',
      views: 234,
      likes: 23,
      comments: 8
    },
    {
      id: 5,
      category: '제품추천',
      title: '네일 영양제 추천해주세요',
      content: '손톱이 자꾸 갈라지고 약해서 영양제 먹으려고 하는데 효과 좋은 제품 있을까요?',
      author: '서연',
      avatar: 'https://readdy.ai/api/search-image?query=beautiful-korean-woman-in-twenties-with-long-straight-hair-wearing-cream-colored-knit-sweater-gentle-expression-natural-beauty-soft-lighting-clean-background&width=200&height=200&seq=comm006&orientation=squarish',
      date: '1시간 전',
      views: 156,
      likes: 12,
      comments: 15
    },
    {
      id: 6,
      category: '피부관리',
      title: '여름 피부관리 루틴 공유해요 ☀️',
      content: '요즘 날씨가 더워지면서 피부가 번들거려서 루틴을 바꿨어요. 아침에는 가볍게...',
      author: '하은',
      avatar: 'https://readdy.ai/api/search-image?query=elegant-korean-woman-with-medium-length-hair-wearing-light-blue-blouse-radiant-smile-glowing-skin-natural-daylight-clean-white-background-professional-beauty-photography&width=200&height=200&seq=comm007&orientation=squarish',
      date: '3시간 전',
      views: 445,
      likes: 34,
      comments: 19,
      image: 'https://readdy.ai/api/search-image?query=beautiful-skincare-routine-products-arranged-aesthetically-with-fresh-flowers-pastel-pink-background-natural-light-feminine-beauty-flatlay-photography-clean-minimal-composition&width=800&height=500&seq=comm008&orientation=landscape'
    },
    {
      id: 7,
      category: '헤어',
      title: '단발 자르고 싶은데 어울릴까요?',
      content: '긴 머리 5년째인데 이번에 단발로 확 자르고 싶어요. 얼굴형 고려해서 조언 부탁드려요!',
      author: '채원',
      avatar: 'https://readdy.ai/api/search-image?query=pretty-korean-woman-with-very-long-black-hair-wearing-white-dress-sweet-smile-natural-makeup-soft-studio-lighting-clean-background-professional-portrait&width=200&height=200&seq=comm009&orientation=squarish',
      date: '4시간 전',
      views: 567,
      likes: 45,
      comments: 31
    },
    {
      id: 8,
      category: '메이크업',
      title: '데일리 메이크업 제품 추천 🎨',
      content: '출근용으로 쓸 가볍고 자연스러운 메이크업 제품 추천해주세요. 쿠션이랑 립 위주로요!',
      author: '유진',
      avatar: 'https://readdy.ai/api/search-image?query=beautiful-korean-woman-in-her-twenties-with-wavy-brown-hair-wearing-beige-cardigan-natural-smile-fresh-makeup-soft-lighting-clean-white-background&width=200&height=200&seq=comm010&orientation=squarish',
      date: '6시간 전',
      views: 678,
      likes: 52,
      comments: 24
    },
    {
      id: 9,
      category: '왁싱',
      title: '브라질리언 왁싱 후 관리법',
      content: '처음 받았는데 관리를 어떻게 해야 할지 모르겠어요. 경험 있으신 분들 조언 부탁드려요!',
      author: '소희',
      avatar: 'https://readdy.ai/api/search-image?query=young-korean-woman-with-shoulder-length-hair-wearing-pink-tshirt-friendly-smile-natural-beauty-soft-studio-lighting-clean-background-professional-portrait&width=200&height=200&seq=comm011&orientation=squarish',
      date: '8시간 전',
      views: 423,
      likes: 28,
      comments: 17
    },
    {
      id: 10,
      category: '속눈썹',
      title: '속눈썹 펌 vs 연장 뭐가 더 좋을까요?',
      content: '둘 다 해본 분들 계신가요? 장단점이 궁금해요. 유지기간이랑 관리 난이도도 알려주세요!',
      author: '다은',
      avatar: 'https://readdy.ai/api/search-image?query=elegant-korean-woman-with-long-straight-black-hair-wearing-white-blouse-gentle-expression-natural-makeup-soft-lighting-clean-white-background-professional-beauty-portrait&width=200&height=200&seq=comm012&orientation=squarish',
      date: '10시간 전',
      views: 789,
      likes: 61,
      comments: 35
    },
    {
      id: 11,
      category: '고민상담',
      title: '네일샵 예약 취소하고 싶은데...',
      content: '급한 일이 생겨서 예약을 취소해야 하는데 당일 취소라 미안해서요. 어떻게 말씀드리는 게 좋을까요?',
      author: '나연',
      avatar: 'https://readdy.ai/api/search-image?query=pretty-korean-woman-in-twenties-with-medium-brown-hair-wearing-cream-sweater-worried-expression-natural-beauty-soft-lighting-clean-background-professional-portrait&width=200&height=200&seq=comm013&orientation=squarish',
      date: '12시간 전',
      views: 345,
      likes: 19,
      comments: 22
    },
    {
      id: 12,
      category: '뷰티팁',
      title: '여름철 메이크업 지속력 높이는 법',
      content: '더운 날씨에 메이크업이 자꾸 무너져서 고민이에요. 제가 쓰는 방법들 공유할게요!',
      author: '지수',
      avatar: 'https://readdy.ai/api/search-image?query=beautiful-korean-woman-with-long-wavy-hair-wearing-light-pink-dress-bright-smile-glowing-makeup-natural-daylight-clean-white-background-professional-beauty-photography&width=200&height=200&seq=comm014&orientation=squarish',
      date: '1일 전',
      views: 1123,
      likes: 87,
      comments: 29,
      image: 'https://readdy.ai/api/search-image?query=beautiful-summer-makeup-products-with-setting-spray-powder-arranged-aesthetically-fresh-flowers-pastel-background-natural-light-feminine-beauty-flatlay-clean-composition&width=800&height=500&seq=comm015&orientation=landscape'
    }
  ];

  const filteredPosts = selectedCategory === '전체' 
    ? recentPosts 
    : recentPosts.filter(post => post.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-b from-rose-50/30 to-white">
      <Navbar isFixed={isNavFixed} />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-light text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            다움 커뮤니티
          </h1>
          <p className="text-base text-gray-600 mb-8">
            뷰티 고민부터 일상 팁까지, 함께 나누는 우리들의 이야기
          </p>
          
          {/* Search Bar */}
          <div className="max-w-2xl mx-auto">
            <div className="relative">
              <input
                type="text"
                placeholder="궁금한 내용을 검색해보세요"
                className="w-full px-6 py-4 pr-12 text-sm rounded-full border border-gray-200 focus:outline-none focus:border-rose-300 focus:ring-2 focus:ring-rose-100 transition-all"
              />
              <button className="absolute right-4 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center text-rose-400 hover:text-rose-500 cursor-pointer">
                <i className="ri-search-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Category Tabs */}
      <section className="sticky top-16 z-40 bg-white/95 backdrop-blur-md border-b border-gray-100 shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center space-x-3 overflow-x-auto scrollbar-hide">
            {categories.map((category) => (
              <button
                key={category.name}
                onClick={() => setSelectedCategory(category.name)}
                className={`flex items-center space-x-2 px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                  selectedCategory === category.name
                    ? 'bg-gradient-to-r from-rose-400 to-pink-400 text-white shadow-md'
                    : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
                }`}
              >
                <i className={`${category.icon} text-base`}></i>
                <span>{category.name}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-8">
            {/* Hot Posts Section */}
            <div>
              <div className="flex items-center space-x-2 mb-6">
                <div className="w-8 h-8 flex items-center justify-center bg-gradient-to-r from-rose-400 to-pink-400 rounded-lg">
                  <i className="ri-fire-fill text-white text-lg"></i>
                </div>
                <h2 className="text-2xl font-light text-gray-800" style={{ fontFamily: 'Playfair Display, serif' }}>
                  인기 게시글
                </h2>
              </div>

              <div className="space-y-4">
                {hotPosts.map((post) => (
                  <div
                    key={post.id}
                    onClick={() => navigate(`/community/post/${post.id}`)}
                    className="bg-white rounded-2xl p-6 hover:shadow-xl transition-all duration-300 border border-gray-100 cursor-pointer"
                  >
                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 flex items-center justify-center rounded-full overflow-hidden flex-shrink-0">
                        <img
                          src={post.avatar}
                          alt={post.author}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>

                      <div className="flex-1">
                        <div className="flex items-center space-x-2 mb-2">
                          <span className="px-3 py-1 bg-rose-50 text-rose-400 text-xs font-medium rounded-full">
                            {post.category}
                          </span>
                          {post.isHot && (
                            <span className="px-2 py-1 bg-gradient-to-r from-rose-400 to-pink-400 text-white text-xs font-medium rounded-full flex items-center space-x-1">
                              <i className="ri-fire-fill"></i>
                              <span>HOT</span>
                            </span>
                          )}
                        </div>

                        <h3 className="text-lg font-medium text-gray-800 mb-2">{post.title}</h3>
                        <p className="text-sm text-gray-600 mb-3 leading-relaxed">{post.content}</p>

                        {post.image && (
                          <div className="relative w-full h-64 rounded-xl overflow-hidden mb-4">
                            <img
                              src={post.image}
                              alt={post.title}
                              className="w-full h-full object-cover object-top"
                            />
                          </div>
                        )}

                        <div className="flex items-center justify-between">
                          <div className="flex items-center space-x-1 text-xs text-gray-500">
                            <span className="font-medium text-gray-700">{post.author}</span>
                            <span>·</span>
                            <span>{post.date}</span>
                          </div>

                          <div className="flex items-center space-x-4 text-sm text-gray-500">
                            <div className="flex items-center space-x-1">
                              <i className="ri-eye-line"></i>
                              <span>{post.views}</span>
                            </div>
                            <button className="flex items-center space-x-1 hover:text-rose-400 transition-colors cursor-pointer whitespace-nowrap">
                              <i className="ri-heart-line"></i>
                              <span>{post.likes}</span>
                            </button>
                            <button className="flex items-center space-x-1 hover:text-rose-400 transition-colors cursor-pointer whitespace-nowrap">
                              <i className="ri-chat-3-line"></i>
                              <span>{post.comments}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Recent Posts Section */}
            <div>
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center space-x-2">
                  <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-lg">
                    <i className="ri-time-line text-gray-600 text-lg"></i>
                  </div>
                  <h2 className="text-2xl font-light text-gray-800" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {selectedCategory === '전체' ? '최신 게시글' : `${selectedCategory} 게시글`}
                  </h2>
                </div>

                <button className="px-5 py-2 bg-gradient-to-r from-rose-400 to-pink-400 text-white text-sm font-medium rounded-full hover:shadow-lg transition-all whitespace-nowrap cursor-pointer">
                  <i className="ri-add-line mr-1"></i>
                  글쓰기
                </button>
              </div>

              <div className="space-y-4">
                {filteredPosts.map((post) => (
                  <div
                    key={post.id}
                    onClick={() => navigate(`/community/post/${post.id}`)}
                    className="bg-white rounded-xl border border-gray-100 p-6 hover:shadow-lg hover:border-rose-200 transition-all cursor-pointer"
                  >
                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 flex items-center justify-center rounded-full overflow-hidden flex-shrink-0">
                        <img
                          src={post.avatar}
                          alt={post.author}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>

                      <div className="flex-1">
                        <div className="flex items-center space-x-2 mb-2">
                          <span className="px-3 py-1 bg-rose-50 text-rose-400 text-xs font-medium rounded-full">
                            {post.category}
                          </span>
                        </div>

                        <h3 className="text-lg font-medium text-gray-800 mb-2">{post.title}</h3>
                        <p className="text-sm text-gray-600 mb-3 leading-relaxed">{post.content}</p>

                        {post.image && (
                          <div className="relative w-full h-48 rounded-xl overflow-hidden mb-4">
                            <img
                              src={post.image}
                              alt={post.title}
                              className="w-full h-full object-cover object-top"
                            />
                          </div>
                        )}

                        <div className="flex items-center justify-between">
                          <div className="flex items-center space-x-1 text-xs text-gray-500">
                            <span className="font-medium text-gray-700">{post.author}</span>
                            <span>·</span>
                            <span>{post.date}</span>
                          </div>

                          <div className="flex items-center space-x-4 text-sm text-gray-500">
                            <div className="flex items-center space-x-1">
                              <i className="ri-eye-line"></i>
                              <span>{post.views}</span>
                            </div>
                            <button className="flex items-center space-x-1 hover:text-rose-400 transition-colors cursor-pointer whitespace-nowrap">
                              <i className="ri-heart-line"></i>
                              <span>{post.likes}</span>
                            </button>
                            <button className="flex items-center space-x-1 hover:text-rose-400 transition-colors cursor-pointer whitespace-nowrap">
                              <i className="ri-chat-3-line"></i>
                              <span>{post.comments}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="text-center mt-8">
                <button className="px-8 py-3 border-2 border-rose-400 text-rose-400 text-sm font-medium rounded-full hover:bg-rose-400 hover:text-white transition-all whitespace-nowrap cursor-pointer">
                  더 많은 게시글 보기
                </button>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Popular Categories */}
            <div className="bg-white rounded-2xl p-6 border border-gray-100">
              <h3 className="text-lg font-medium text-gray-800 mb-4 flex items-center space-x-2">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-hashtag text-rose-400"></i>
                </div>
                <span>인기 카테고리</span>
              </h3>
              <div className="space-y-3">
                {categories.slice(1, 8).map((category) => (
                  <button
                    key={category.name}
                    onClick={() => setSelectedCategory(category.name)}
                    className="w-full flex items-center justify-between px-4 py-3 rounded-xl hover:bg-rose-50 transition-all cursor-pointer group"
                  >
                    <div className="flex items-center space-x-3">
                      <div className="w-8 h-8 flex items-center justify-center bg-rose-50 rounded-lg group-hover:bg-rose-100 transition-colors">
                        <i className={`${category.icon} text-rose-400`}></i>
                      </div>
                      <span className="text-sm text-gray-700 group-hover:text-rose-400 transition-colors">
                        {category.name}
                      </span>
                    </div>
                    <i className="ri-arrow-right-s-line text-gray-400 group-hover:text-rose-400 transition-colors"></i>
                  </button>
                ))}
              </div>
            </div>

            {/* Community Rules */}
            <div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-2xl p-6 border border-rose-100">
              <h3 className="text-lg font-medium text-gray-800 mb-4 flex items-center space-x-2">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-information-line text-rose-400"></i>
                </div>
                <span>커뮤니티 가이드</span>
              </h3>
              <ul className="space-y-3 text-sm text-gray-600">
                <li className="flex items-start space-x-2">
                  <i className="ri-check-line text-rose-400 mt-0.5"></i>
                  <span>서로 존중하고 배려하는 마음으로 소통해요</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-check-line text-rose-400 mt-0.5"></i>
                  <span>개인정보는 공유하지 않아요</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-check-line text-rose-400 mt-0.5"></i>
                  <span>광고성 게시글은 삼가주세요</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-check-line text-rose-400 mt-0.5"></i>
                  <span>유익한 정보를 나누고 함께 성장해요</span>
                </li>
              </ul>
            </div>

            {/* Quick Links */}
            <div className="bg-white rounded-2xl p-6 border border-gray-100">
              <h3 className="text-lg font-medium text-gray-800 mb-4 flex items-center space-x-2">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-links-line text-rose-400"></i>
                </div>
                <span>바로가기</span>
              </h3>
              <div className="space-y-2">
                <a
                  href="/nearby-shops"
                  className="flex items-center justify-between px-4 py-3 rounded-xl hover:bg-rose-50 transition-all cursor-pointer group"
                >
                  <span className="text-sm text-gray-700 group-hover:text-rose-400 transition-colors">
                    주변 뷰티샵 찾기
                  </span>
                  <i className="ri-arrow-right-s-line text-gray-400 group-hover:text-rose-400 transition-colors"></i>
                </a>
                <a
                  href="/booking"
                  className="flex items-center justify-between px-4 py-3 rounded-xl hover:bg-rose-50 transition-all cursor-pointer group"
                >
                  <span className="text-sm text-gray-700 group-hover:text-rose-400 transition-colors">
                    예약하기
                  </span>
                  <i className="ri-arrow-right-s-line text-gray-400 group-hover:text-rose-400 transition-colors"></i>
                </a>
                <a
                  href="/"
                  className="flex items-center justify-between px-4 py-3 rounded-xl hover:bg-rose-50 transition-all cursor-pointer group"
                >
                  <span className="text-sm text-gray-700 group-hover:text-rose-400 transition-colors">
                    홈으로 돌아가기
                  </span>
                  <i className="ri-arrow-right-s-line text-gray-400 group-hover:text-rose-400 transition-colors"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
